<script lang="ts">
  import { onMount } from "svelte";
  import { X } from "lucide-svelte";

  export let title: string;
  export let context: string;
  export let onclose: () => void;
  export let returnFocus: HTMLElement | null = null;
  export let fallbackFocus: HTMLElement | null = null;

  let panel: HTMLElement;
  let closeButton: HTMLButtonElement;

  function focusable(): HTMLElement[] {
    return Array.from(
      panel.querySelectorAll<HTMLElement>(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    );
  }

  function keydown(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      event.preventDefault();
      onclose();
      return;
    }
    if (event.key !== "Tab") return;
    const items = focusable();
    const first = items[0];
    const last = items.at(-1);
    if (!first || !last) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  onMount(() => {
    closeButton.focus();
    return () => {
      if (returnFocus?.isConnected) returnFocus.focus();
      else fallbackFocus?.focus();
    };
  });
</script>

<div class="drawer-layer">
  <button class="drawer-scrim" type="button" aria-hidden="true" tabindex="-1" onclick={onclose}></button>
  <div
    class="drawer"
    bind:this={panel}
    role="dialog"
    aria-modal="true"
    aria-labelledby="drawer-title"
    tabindex="-1"
    onkeydown={keydown}
  >
    <header class="drawer__header">
      <div>
        <h2 id="drawer-title">{title}</h2>
        <p class="drawer__context">{context}</p>
      </div>
      <button class="icon-button" bind:this={closeButton} type="button" onclick={onclose} aria-label={`Close ${title}`}>
        <X size={21} />
      </button>
    </header>
    <div class="drawer__body"><slot /></div>
  </div>
</div>
